import React, { FC, useState } from 'react';
import classnames from 'classnames';

import DangerouslySetInnerHtml from 'components/DangerouslySetInnerHtml';
import { initRecaptcha, getRecaptchaToken } from 'utils/recaptchaUtils';

import formSchema from './formUtils/formSchema';
import formSchemaExtended from './formUtils/formSchemaExtended';
import controlForm from './formUtils/controlForm';
import renderField from './formUtils/renderField';
import ButtonField from './Components/ButtonField';

import { ContactFormProps } from './models';

import './ContactForm.scss';

const ContactForm: FC<ContactFormProps> = ({
  className,
  marketTranslations,
  translations,
  ...other
}) => {
  const { privacyInfoText } = marketTranslations;
  const [fields, handleFieldChange, handleSubmit, isLoading, phoneCode] = controlForm(
    marketTranslations.extended ? formSchemaExtended : formSchema,
    other
  );
  const translationKeys = { ...marketTranslations, ...translations };
  const key: string | undefined = process.env.GATSBY_GOOGLE_CAPTCHA_SITE_KEY;
  const [isFocused, setFocus] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!key) return;
    handleSubmit(await getRecaptchaToken(key));
  };

  const handleFocus = () => {
    if (isFocused || !key) return;
    setFocus(true);
    initRecaptcha(key);
  };

  return (
    <div className={classnames('contact-form', className, { 'contact-form__overlay': isLoading })}>
      <form onFocus={handleFocus} aria-label="form">
        {fields
          .filter((item) => {
            if (!item.visibilityCondition) return true;
            const comparer = fields.find(({ id }) => item.visibilityCondition?.field === id);
            return comparer.value === item.visibilityCondition.value;
          })
          .map((item) => renderField(item, handleFieldChange, translationKeys, phoneCode))}
        <DangerouslySetInnerHtml
          className="contact-form__privacy-info-text contact-info__paragraph"
          html={privacyInfoText}
        />
        <ButtonField
          onClick={submit}
          ariaLabel="submit button"
          value="submitLabel"
          ts={translationKeys}
        />
      </form>
    </div>
  );
};

export default ContactForm;
